import { useMemo } from "react"

export type UseTotalParams = {
    estancia: any[]
    ordenes: any[]
    key: string
    descuento?: number
}

export function useTotal({ estancia, ordenes, key, descuento = 0 }: UseTotalParams) {
    const totalEstancia = estancia.reduce((sum, estancia) => {
        return sum + Number(estancia.total || 0)
    }, 0)
    const totalOrdenes = ordenes.reduce((sum, orden) => {
        return sum + (orden.saldo_pendiente || 0)
    }, 0)

    const total = useMemo(() => {
        const base = key === "Estancia" ? totalEstancia : totalOrdenes
        return Math.max(0, base - descuento)
    }, [key, totalEstancia, totalOrdenes, descuento])

    return {
        total,
    }
}
